import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var BlockerButtonsInlineStyles = /*#__PURE__*/function () {
  function BlockerButtonsInlineStyles() {
    _classCallCheck(this, BlockerButtonsInlineStyles);
  }

  _createClass(BlockerButtonsInlineStyles, null, [{
    key: "save",
    value: function save(_ref, isHover, framed) {
      var acceptAll = _ref.decision.acceptAll,
          borderRadius = _ref.layout.borderRadius,
          _ref$bodyDesign = _ref.bodyDesign,
          acceptAllFontSize = _ref$bodyDesign.acceptAllFontSize,
          acceptAllBg = _ref$bodyDesign.acceptAllBg,
          acceptAllTextAlign = _ref$bodyDesign.acceptAllTextAlign,
          acceptAllBorderColor = _ref$bodyDesign.acceptAllBorderColor,
          acceptAllPadding = _ref$bodyDesign.acceptAllPadding,
          acceptAllBorderWidth = _ref$bodyDesign.acceptAllBorderWidth,
          acceptAllFontColor = _ref$bodyDesign.acceptAllFontColor,
          acceptAllHoverBg = _ref$bodyDesign.acceptAllHoverBg,
          acceptAllHoverFontColor = _ref$bodyDesign.acceptAllHoverFontColor,
          acceptAllHoverBorderColor = _ref$bodyDesign.acceptAllHoverBorderColor,
          antiAdBlocker = _ref.customCss.antiAdBlocker;
      return this.common({
        name: "accept-all",
        type: acceptAll,
        borderRadius: borderRadius,
        bg: acceptAllBg,
        hoverBg: acceptAllHoverBg,
        fontSize: acceptAllFontSize,
        textAlign: acceptAllTextAlign,
        fontColor: acceptAllFontColor,
        hoverFontColor: acceptAllHoverFontColor,
        borderWidth: acceptAllBorderWidth,
        borderColor: acceptAllBorderColor,
        hoverBorderColor: acceptAllHoverBorderColor,
        padding: acceptAllPadding,
        antiAdBlocker: antiAdBlocker
      }, isHover, framed);
    }
  }, {
    key: "showInfo",
    value: function showInfo(_ref2, isHover, framed) {
      var acceptIndividual = _ref2.decision.acceptIndividual,
          borderRadius = _ref2.layout.borderRadius,
          _ref2$bodyDesign = _ref2.bodyDesign,
          acceptIndividualFontSize = _ref2$bodyDesign.acceptIndividualFontSize,
          acceptIndividualBg = _ref2$bodyDesign.acceptIndividualBg,
          acceptIndividualTextAlign = _ref2$bodyDesign.acceptIndividualTextAlign,
          acceptIndividualBorderColor = _ref2$bodyDesign.acceptIndividualBorderColor,
          acceptIndividualPadding = _ref2$bodyDesign.acceptIndividualPadding,
          acceptIndividualBorderWidth = _ref2$bodyDesign.acceptIndividualBorderWidth,
          acceptIndividualFontColor = _ref2$bodyDesign.acceptIndividualFontColor,
          acceptIndividualHoverBg = _ref2$bodyDesign.acceptIndividualHoverBg,
          acceptIndividualHoverFontColor = _ref2$bodyDesign.acceptIndividualHoverFontColor,
          acceptIndividualHoverBorderColor = _ref2$bodyDesign.acceptIndividualHoverBorderColor,
          antiAdBlocker = _ref2.customCss.antiAdBlocker;
      return this.common({
        name: "accept-individual",
        type: acceptIndividual,
        borderRadius: borderRadius,
        bg: acceptIndividualBg,
        hoverBg: acceptIndividualHoverBg,
        fontSize: acceptIndividualFontSize,
        textAlign: acceptIndividualTextAlign,
        fontColor: acceptIndividualFontColor,
        hoverFontColor: acceptIndividualHoverFontColor,
        borderWidth: acceptIndividualBorderWidth,
        borderColor: acceptIndividualBorderColor,
        hoverBorderColor: acceptIndividualHoverBorderColor,
        padding: acceptIndividualPadding,
        antiAdBlocker: antiAdBlocker
      }, isHover, framed);
    }
  }, {
    key: "hero",
    value: function hero(_ref3, isHover, framed) {
      var acceptAll = _ref3.decision.acceptAll,
          borderRadius = _ref3.layout.borderRadius,
          _ref3$bodyDesign = _ref3.bodyDesign,
          acceptAllFontSize = _ref3$bodyDesign.acceptAllFontSize,
          acceptAllBg = _ref3$bodyDesign.acceptAllBg,
          acceptAllTextAlign = _ref3$bodyDesign.acceptAllTextAlign,
          acceptAllBorderColor = _ref3$bodyDesign.acceptAllBorderColor,
          acceptAllPadding = _ref3$bodyDesign.acceptAllPadding,
          acceptAllBorderWidth = _ref3$bodyDesign.acceptAllBorderWidth,
          acceptAllFontColor = _ref3$bodyDesign.acceptAllFontColor,
          acceptAllHoverBg = _ref3$bodyDesign.acceptAllHoverBg,
          acceptAllHoverFontColor = _ref3$bodyDesign.acceptAllHoverFontColor,
          acceptAllHoverBorderColor = _ref3$bodyDesign.acceptAllHoverBorderColor,
          antiAdBlocker = _ref3.customCss.antiAdBlocker;
      return this.common({
        name: "accept-all",
        type: acceptAll,
        borderRadius: borderRadius,
        bg: acceptAllBg,
        hoverBg: acceptAllHoverBg,
        fontSize: acceptAllFontSize,
        textAlign: acceptAllTextAlign,
        fontColor: acceptAllFontColor,
        hoverFontColor: acceptAllHoverFontColor,
        borderWidth: acceptAllBorderWidth,
        borderColor: acceptAllBorderColor,
        hoverBorderColor: acceptAllHoverBorderColor,
        padding: acceptAllPadding,
        boxShadow: "rgb(0 0 0 / 15%) 0px 0px 100px 30px, rgb(0 0 0 / 40%) 0px 2px 5px 1px",
        zIndex: 9,
        antiAdBlocker: antiAdBlocker
      }, isHover, framed);
    }
  }, {
    key: "common",
    value: function common(_ref4, isHover, framed) {
      var name = _ref4.name,
          type = _ref4.type,
          borderRadius = _ref4.borderRadius,
          bg = _ref4.bg,
          hoverBg = _ref4.hoverBg,
          fontSize = _ref4.fontSize,
          textAlign = _ref4.textAlign,
          fontColor = _ref4.fontColor,
          hoverFontColor = _ref4.hoverFontColor,
          borderWidth = _ref4.borderWidth,
          borderColor = _ref4.borderColor,
          hoverBorderColor = _ref4.hoverBorderColor,
          padding = _ref4.padding,
          boxShadow = _ref4.boxShadow,
          zIndex = _ref4.zIndex,
          antiAdBlocker = _ref4.antiAdBlocker;
      var style = {
        textDecoration: type === "link" ? "underline" : "none",
        borderRadius: +borderRadius,
        cursor: type === "button" ? "pointer" : undefined,
        backgroundColor: type === "button" ? isHover ? hoverBg : bg : undefined,
        fontSize: +fontSize,
        textAlign: textAlign,
        color: isHover ? hoverFontColor : fontColor,
        transition: "background-color 250ms, color 250ms, border-color 250ms",
        marginBottom: 10,
        border: type === "button" && borderWidth > 0 ? "".concat(borderWidth, "px solid ").concat(isHover ? hoverBorderColor : borderColor) : undefined,
        padding: padding.map(function (p) {
          return "".concat(p, "px");
        }).join(" "),
        overflow: "hidden",
        outline: framed ? "rgb(255, 94, 94) solid 5px" : undefined,
        boxShadow: boxShadow,
        zIndex: zIndex
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-btn-".concat(name),
        style: style
      };
    }
  }]);

  return BlockerButtonsInlineStyles;
}();

export { BlockerButtonsInlineStyles };